module.exports = __webpack_public_path__ + "img/j.83a4ff2c.jpg";